import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function Add({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9375 3.00049V21.0005V3.00049Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.9375 12.0005H21.9375H3.9375Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ArrowRight({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6875 12.0369H21.6855H3.6875Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3672 3.00049L21.1373 10.7706C21.8704 11.508 21.8704 12.6989 21.1373 13.4363L13.5752 20.9985"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}
export function ArrowLeft({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8123 12.0377H3.81445H21.8123Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1323 3.00159L4.36225 10.7716C3.62925 11.509 3.62925 12.6999 4.36225 13.4373L11.9244 20.9994"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </SvgIconComponent>
  )
}

export function Burguer({ size, ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      {...props}
    >
      <path
        d="M3.41992 12.0002H21.7056"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M3.41992 4.88916H21.7056"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M3.41992 19.1113H21.7056"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </SvgIconComponent>
  )
}

export function Cancel({
  size,
  stroke = '#141A21',
  strokeWidth = 6,
  ...props
}) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      size={size}
      {...props}
    >
      <path
        d="M42 6L6 42"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M6 6L42 42"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </SvgIconComponent>
  )
}

export function CancelBolder({
  size,
  stroke = '#141A21',
  strokeWidth = 6,
  ...props
}) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      size={size}
      {...props}
    >
      <path
        d="M35.1429 12.8572L12.8571 35.1429"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M12.8571 12.8572L35.1429 35.1429"
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </SvgIconComponent>
  )
}

export function ChevronLeft({
  stroke = '#141A21',
  strokeWidth = 1.333,
  size,
  ...props
}) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      stroke={stroke}
      {...props}
    >
      <path
        d="M34.7793 4L13.9993 24L34.7718 44"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </SvgIconComponent>
  )
}

export function ChevronLeftSmall({ stroke = '#141A21', size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      stroke={stroke}
      {...props}
    >
      <path
        d="M10 4L6 8L9.99855 12"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
      />
    </SvgIconComponent>
  )
}

export function ChevronRight({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      height="17"
      width="16"
      fill="none"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      stroke={stroke}
      {...props}
    >
      <path
        d="M4.66756 1.77808L11.5918 8.44474L4.66756 15.1114"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
      />
    </SvgIconComponent>
  )
}

export function ChevronRightSmall({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      stroke={stroke}
      {...props}
    >
      <path
        d="M6 4L10 8L6 12"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
      />
    </SvgIconComponent>
  )
}

export function ChevronUpSmall({
  size,
  stroke = '#141A21',
  strokeWidth = 6,
  ...props
}) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      size={size}
      {...props}
    >
      <path
        d="M8 29.9086L23.9618 14L40 30"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </SvgIconComponent>
  )
}

export function ChevronUp({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...props}
    >
      <path
        d="M2.9375 18.194L12.9136 7.86719L22.9375 18.2534"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function ChevronDownSmall({
  size,
  stroke = '#141A21',
  strokeWidth = 6,
  ...props
}) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      size={size}
      {...props}
    >
      <path
        d="M8 18.0914L23.9618 34L40 18"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </SvgIconComponent>
  )
}

export function ChevronDown({ size, stroke = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      size={size}
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      {...props}
    >
      <path
        d="M2.3125 7.05764L12.2886 17.0005L22.3125 7.00049"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function Collapse({ size, ...props }) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M44 12L32 24L44 36"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M16 12L4 24L16 36"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </SvgIconComponent>
  )
}

export function Confirm({ size, stroke, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M4 8.00004L6.70096 10.75L12 5.5"
        stroke={stroke ?? '#141A21'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

export function Context({ size, fill = '#141A21', ...props }) {
  return (
    <SvgIconComponent
      height="48"
      width="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      fill={fill}
      {...props}
    >
      <path
        d="M12 27.74C14.0711 27.74 15.75 26.0611 15.75 23.99C15.75 21.9189 14.0711 20.24 12 20.24C9.92893 20.24 8.25 21.9189 8.25 23.99C8.25 26.0611 9.92893 27.74 12 27.74Z"
        fill={fill}
        fillRule="evenodd"
      />
      <path
        d="M24 27.74C26.0711 27.74 27.75 26.0611 27.75 23.99C27.75 21.9189 26.0711 20.24 24 20.24C21.9289 20.24 20.25 21.9189 20.25 23.99C20.25 26.0611 21.9289 27.74 24 27.74Z"
        fill={fill}
        fillRule="evenodd"
      />
      <path
        d="M36 27.74C38.0711 27.74 39.75 26.0611 39.75 23.99C39.75 21.9189 38.0711 20.24 36 20.24C33.9289 20.24 32.25 21.9189 32.25 23.99C32.25 26.0611 33.9289 27.74 36 27.74Z"
        fill={fill}
        fillRule="evenodd"
      />
    </SvgIconComponent>
  )
}

export function Expand({ size, ...props }) {
  return (
    <SvgIconComponent
      height="16"
      width="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      {...props}
    >
      <path
        d="M1.33398 4L5.33398 8L1.33398 12"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M10.668 4L14.668 8L10.668 12"
        stroke="#141A21"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function Substract({ size, ...props }) {
  return (
    <SvgIconComponent
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#141A21"
      size={size}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3125 12.8672H21.3125H3.3125Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}

Add.propTypes = iconPropTypes
ArrowRight.propTypes = iconPropTypes
ArrowLeft.propTypes = iconPropTypes
Burguer.propTypes = iconPropTypes
Cancel.propTypes = iconPropTypes
CancelBolder.propTypes = iconPropTypes
ChevronLeft.propTypes = iconPropTypes
ChevronLeftSmall.propTypes = iconPropTypes
ChevronRight.propTypes = iconPropTypes
ChevronRightSmall.propTypes = iconPropTypes
ChevronUp.propTypes = iconPropTypes
ChevronUpSmall.propTypes = iconPropTypes
ChevronDownSmall.propTypes = iconPropTypes
ChevronDown.propTypes = iconPropTypes
Collapse.propTypes = iconPropTypes
Confirm.propTypes = iconPropTypes
Context.propTypes = iconPropTypes
Expand.propTypes = iconPropTypes
Substract.propTypes = iconPropTypes

const iconsEssentials = {
  Add,
  ArrowRight,
  ArrowLeft,
  Burguer,
  Cancel,
  CancelBolder,
  ChevronLeft,
  ChevronLeftSmall,
  ChevronRight,
  ChevronRightSmall,
  ChevronUp,
  ChevronUpSmall,
  ChevronDown,
  ChevronDownSmall,
  Collapse,
  Confirm,
  Context,
  Expand,
  Substract
}

export default iconsEssentials
